import * as React from "react";
import type { SVGProps } from "react";
const SvgWallet01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M21.6 16.56v1a1 1 0 0 0 1-1zm0-5.28h1a1 1 0 0 0-1-1zM7.14 6.119A1 1 0 1 0 8.22 7.8l-.54-.841zM14.4 2.64l.79-.614a1 1 0 0 0-1.33-.227zm2.57 4.934a1 1 0 1 0 1.58-1.228l-.79.614zm4.63 8.986v-1h-3.12v2h3.12zm-3.12-5.28v1h3.12v-2h-3.12zm3.12 0h-1v5.28h2v-5.28zm-5.76 2.64h1c0-.906.734-1.64 1.64-1.64v-2a3.64 3.64 0 0 0-3.64 3.64zm2.64 2.64v-1a1.64 1.64 0 0 1-1.64-1.64h-2a3.64 3.64 0 0 0 3.64 3.64zm-10.8-9.6.54.841 6.72-4.32-.54-.841-.54-.841-6.72 4.32zm6.72-4.32-.79.614 3.36 4.32.79-.614.79-.614-3.36-4.32zM3.36 6.96v1h16.32v-2H3.36zm16.32 14.4v-1H3.36v2h16.32zM2.4 20.4h1V7.92h-2V20.4zm.96.96v-1a.04.04 0 0 1 .04.04h-2a1.96 1.96 0 0 0 1.96 1.96zm17.28-.96h-1a.04.04 0 0 1 .04-.04v2a1.96 1.96 0 0 0 1.96-1.96zm-.96-13.44v1a.04.04 0 0 1-.04-.04h2a1.96 1.96 0 0 0-1.96-1.96zm-16.32 0v-1A1.96 1.96 0 0 0 1.4 7.92h2a.04.04 0 0 1-.04.04zm17.28 10.32h-1v3.12h2v-3.12zm0-9.36h-1v2.52h2V7.92z"
    />
  </svg>
);
export default SvgWallet01;
